export default __webpack_public_path__ + "static/media/Cerrar.bb89e7b1.svg";